type Option = {
  label: string;
};

export const compareOptionsByLabel = (optionA: Option, optionB: Option): number => {
  const labelA = optionA?.label ?? '';
  const labelB = optionB?.label ?? '';
  return labelA.toLowerCase().localeCompare(labelB.toLowerCase());
};